<template>
  <v-card
    class="pa-4 mb-4"
    data-cy="card_nota_fiscal"
  >
    <p
      class="primary--text mb-0 subtitle-2 font-weight-bold text-uppercase text-center"
      data-cy="card_nota_fiscal_titulo"
    >
      Nota Fiscal Eletrônica
    </p>
    <div
      v-for="(nota, key) in notas"
      :key="`group-btn-${key}`"
      :class="notas.length > 1 || 'pt-5'"
    >
      <p
        v-if="notas.length > 1"
        data-cy="card_nota_fiscal_subtitulo"
        class="primary--text body-2 pt-5 mb-2"
      >
        <strong>Nota fiscal {{ key + 1 }}</strong>
      </p>
      <div class="d-flex justify-space-between">
        <template
          v-for="(arquivo, index) in nota"
        >
          <v-btn
            :key="`btn-notas-${index}-${key}`"
            :data-cy="`card_nota_fiscal-btn-${index}-${key + 1}`"
            :href="arquivo"
            color="primary"
            class="px-3"
            download
            small
            target="_blank"
            text
            @click="scoreConsumidor(dadosTransacao.id)"
          >
            Baixar em {{ index }}
          </v-btn>
          <v-divider
            v-if="index === 'pdf'"
            :key="`btn-notas-${index}`"
            style="height:16px"
            class="mt-2"
            vertical
          />
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import api from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'CardNotaFiscal',

  props: {
    notas: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState(['dadosTransacao']),
  },

  methods: {
    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'download_nf',
        orderId,
      });
    },
  },
};
</script>
